import { sredProjectCategoryLabel, SelectedSredProjectCategory } from '@common/neo.tax';
import { BadgeColorVariant } from '@ui-components/neo.tax';

export type ProjectBadgeConfig = {
  label: string;
  colorVariant: BadgeColorVariant;
  description?: string;
  sortOrdinal: number;
};

const sredCategoryBadgeConfigMap: Record<
  SelectedSredProjectCategory,
  Omit<ProjectBadgeConfig, 'description' | 'label'>
> = {
  SRED_CREDIT: {
    colorVariant: 'default',
    sortOrdinal: 1,
  },
  NOT_STARTED_OR_NONE: {
    colorVariant: 'default',
    sortOrdinal: 2,
  },
} as const;

export const getSredCategoryBadgeConfig = ({
  consideredForSred,
}: {
  consideredForSred: boolean;
}): ProjectBadgeConfig => {
  if (consideredForSred) {
    return {
      ...sredCategoryBadgeConfigMap.SRED_CREDIT,
      label: sredProjectCategoryLabel[SelectedSredProjectCategory.SRED_CREDIT],
    };
  }

  return {
    ...sredCategoryBadgeConfigMap.NOT_STARTED_OR_NONE,
    label: sredProjectCategoryLabel[SelectedSredProjectCategory.NOT_STARTED_OR_NONE],
  };
};

const sredDeterminationBadgeConfigMap: Record<string, Omit<ProjectBadgeConfig, 'description'>> = {
  SRED_CREDIT_ELIGIBLE: {
    colorVariant: 'green',
    label: 'SR&ED Credit Eligible',
    sortOrdinal: 1,
  },
  NEEDS_REVIEW: {
    colorVariant: 'yellow',
    label: 'Needs Review',
    sortOrdinal: 2,
  },
  NOT_QUALIFIED: {
    colorVariant: 'red',
    label: 'Not Qualified',
    sortOrdinal: 3,
  },
} as const;

/**
 * Maps the backend aiGuidance field to proper badge configuration for SR&ED projects
 * This is used when we have the pre-calculated aiGuidance value from the backend
 */
export const getAiGuidanceBadgeConfig = (aiGuidance: string | null | undefined): ProjectBadgeConfig | undefined => {
  if (!aiGuidance) return undefined;

  const badgeConfigMap: Record<string, Omit<ProjectBadgeConfig, 'description'>> = {
    'SR&ED Credit Eligible': {
      ...sredDeterminationBadgeConfigMap.SRED_CREDIT_ELIGIBLE,
    },
    'Needs Review': {
      ...sredDeterminationBadgeConfigMap.NEEDS_REVIEW,
    },
    'Not Qualified': {
      ...sredDeterminationBadgeConfigMap.NOT_QUALIFIED,
    },
  };

  const config = badgeConfigMap[aiGuidance];
  if (!config) return undefined;

  return {
    ...config,
    description: '',
  };
};
